<div>
  <div class="hero">
    <div>
      <div class="image">
        <img src="/assets/tytnetwork-light-shadow.png" />
        <div class="tagline">7 Billion Views | 6 Million Subscribers</div>
      </div>
      <div class="flex-spacer"></div>

    </div>
  </div>

  <div class="success-container">

    <div class="confirmation-title">Welcome to TYT Network!</div>
    <img src="https://puu.sh/t5Dqk.gif" class="confirmation-dance"/>
    <div class="confirmation-msg">Thank you for joining!</div>
    <div class="reporting-msg" [innerHTML]="confirmationText | trustHtml"></div>

    <div class="buttons">
      <a href="https://tytnetwork.com/member-content/">
        <button class="d-block sign-in btn btn-primary mx-auto">Go to Member Content</button>
      </a>
    </div>
  </div>
</div>